import { useMemo } from 'react';
import AsyncSelect from 'react-select/async';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';

import { map } from '../../network';

const customSelectStyles = {
    dropdownIndicator: (base) => ({ ...base, color: 'rgb(157, 157, 157)' }),
    control: (base) => ({
        ...base,
        border: '0',
        boxShadow: 'none',
        backgroundColor: '#f9f9f9',
        '&:hover': {
            border: '0',
        },
    }),
    option: (styles, { isFocused, isSelected }) => {
        return {
            ...styles,
            backgroundColor: isSelected || isFocused ? '#e0e1e3' : '#f9fafb',
            color: isSelected || isFocused ? '#fff' : '#000',
        };
    },
    placeholder: (defaultStyles) => ({
        ...defaultStyles,
        fontSize: 14,
        fontWeight: 500,
        color: '#9a9ab0',
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: 14,
        fontWeight: 500,
    }),
};

export const GeoAddressSelect = ({ loading = false, setFieldValue, address }) => {
    const { t, i18n } = useTranslation();

    const defaultOption = address? { formatted_address: address, place_id: address }: null

    const debouncedSearch = useMemo(
        () =>
            debounce((inputValue, callback) => {
                map.getGeocodeList(inputValue, i18n.language).then((options) => callback(options));
            }, 500),
        []
    );

    const onSearchAddress = (inputValue, callback) => {
        if (inputValue.length < 3) {
            return Promise.resolve([]);
        }
        debouncedSearch(inputValue, callback);
    };

    const addressNoOptionsMessage = ({ inputValue }) => {
        if (inputValue.length < 3) {
            return t('Enter first 3 chars');
        }
        return t('No data');
    };

    return (
        <AsyncSelect
            cacheOptions
            loadOptions={onSearchAddress}
            noOptionsMessage={addressNoOptionsMessage}
            loadingMessage={() => t('Loading')}
            disabled={loading}
            value={defaultOption}
            placeholder={t('Address')}
            getOptionLabel={(opt) => opt.formatted_address}
            getOptionValue={(opt) => opt.place_id}
            styles={customSelectStyles}
            onChange={(v) => {
                setFieldValue('address', v.formatted_address);
                setFieldValue('lng', v.geometry.location.lng);
                setFieldValue('lat', v.geometry.location.lat);
            }}
        />
    );
};
